/* DEMONTHA mega menü — assets/dmt-mega.js
 *
 * Tema JS'i (base.js → MegaMenuSection) mobilde üst maddenin kendisini açıcıya
 * çeviriyordu: link hem gidiyor hem açıyordu, ikisi birden olmuyordu. Bu dosya
 * o davranışın yerine geçiyor. mega-menu.liquid, tema JS'inin bağlandığı
 * sınıfları (wt-page-nav-mega__link--parent, __item--parent) bilerek
 * kullanmıyor; dolayısıyla çakışma yok, tema JS'i bu menüde hiçbir şeye
 * bağlanmıyor.
 *
 * Sorumluluklar
 *   1. Mobil akordeon (ayrı açma düğmesi, aria-expanded)
 *   2. Masaüstü açılırın ekran kenarına taşmaması (flip)
 *   3. Esc ile masaüstü açılırı kapatma
 *   4. Çekmece açıkken arka planın kaymaması (iOS Safari dahil)
 */
(function () {
  'use strict';

  var DESKTOP = 1200;
  var OPEN = 'dmt-mega__item--open';
  var FLIP = 'dmt-mega__item--flip';

  function isDesktop() {
    return (
      window.matchMedia('(min-width: ' + DESKTOP + 'px)').matches &&
      !document.body.classList.contains('mobile-nav')
    );
  }

  /* ---------------------------------------------------------------- akordeon */

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('.dmt-mega__item'));
  }

  function setOpen(item, open) {
    if (!item) return;
    item.classList.toggle(OPEN, open);
    var toggle = item.querySelector('[data-dmt-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    items().forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest ? event.target.closest('[data-dmt-toggle]') : null;
    if (!toggle) return;
    event.preventDefault();
    /* Masaüstünde açılır zaten hover/focus ile açılıyor; tıklama bir şey
       yapmasın, yoksa fare ayrıldıktan sonra panel açık kalır. */
    if (isDesktop()) return;
    var item = toggle.closest('.dmt-mega__item');
    var willOpen = !item.classList.contains(OPEN);
    closeAll(item);
    setOpen(item, willOpen);
  });

  /* Masaustunde panel CSS ile aciliyor:
       .dmt-mega__item:hover > .dmt-mega__panel
       .dmt-mega__item:focus-within > .dmt-mega__panel
     Fare ile ust basliga tiklandiginda dugme ODAKTA KALIYOR ve :focus-within
     o paneli acik tutuyordu; fare baska maddeye gectiginde ikinci panel :hover
     ile aciliyor ve IKI PANEL BIRDEN acik kaliyordu (kullanici bildirdi).
     Cozum: fare kaynakli odagi engelle. mousedown'da preventDefault odak
     verilmesini onler; tiklama olayini ve baglanti gezinmesini etkilemez.
     KLAVYE ODAGI KORUNUR - Tab ile gezinende :focus-within calismaya devam eder. */
  document.addEventListener('mousedown', function (event) {
    if (!isDesktop()) return;
    var head = event.target.closest ? event.target.closest('.dmt-mega__link--heading') : null;
    if (head) event.preventDefault();
  });

  /* Emniyet agi: panel icindeki bir baglantiya tiklanip geri donuldugunde odak
     o maddede kalabilir. Baska bir maddeye gelindiginde onceki odagi birak. */
  function releaseForeignFocus(current) {
    var a = document.activeElement;
    if (!a || !a.blur || !a.closest) return;
    var owner = a.closest('.dmt-mega__item');
    if (owner && owner !== current) a.blur();
  }

  /* --------------------------------------------------- masaüstü kenar taşması */

  function placePanel(item) {
    var panel = item.querySelector('[data-dmt-panel]');
    if (!panel || panel.classList.contains('dmt-mega__panel--wide')) return;
    item.classList.remove(FLIP);
    var rect = panel.getBoundingClientRect();
    if (rect.right > document.documentElement.clientWidth - 8) {
      item.classList.add(FLIP);
    }
  }

  function bindDesktop() {
    items().forEach(function (item) {
      if (item.dataset.dmtBound === '1') return;
      item.dataset.dmtBound = '1';

      var toggle = item.querySelector('[data-dmt-toggle]');

      ['mouseenter', 'focusin'].forEach(function (type) {
        item.addEventListener(type, function () {
          if (!isDesktop()) return;
          if (type === 'mouseenter') releaseForeignFocus(item);
          placePanel(item);
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        });
      });

      ['mouseleave', 'focusout'].forEach(function (type) {
        item.addEventListener(type, function (event) {
          if (!isDesktop()) return;
          if (type === 'focusout' && item.contains(event.relatedTarget)) return;
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  /* --------------------------------------------------------------------- Esc */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    if (isDesktop()) {
      var active = document.activeElement;
      if (active && active.closest && active.closest('.dmt-mega__item')) {
        active.blur();
      }
      closeAll(null);
    } else {
      closeAll(null);
    }
  });

  /* -------------------------------------------- arka plan kaydırma kilidi */

  var scrollY = 0;
  var locked = false;
  var body = document.body;

  /* Kaydirma cubugunun genisligini kilit ACILMADAN once olcup sakliyoruz.
     Tema, menu-open ile ayni anda .menu-drawer-overlay-on (overflow:hidden)
     ekliyor; MutationObserver tetiklendiginde cubuk coktan kalkmis oluyor ve
     yerinde olcum 0 donuyor. Gercek telefonda bu deger zaten 0. */
  var barCache = 0;

  function measureBar() {
    if (locked) return;
    var b = window.innerWidth - document.documentElement.clientWidth;
    if (b >= 0) barCache = b;
  }

  function lock() {
    if (locked || isDesktop()) return;
    locked = true;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    /* Masaustu tarayicida govdeyi fixed yapmak kaydirma cubugunu kaldirir ve
       sayfa 15px genisler. Telafi etmezsek cekmece acilirken icerik zipliyor.
       Gercek telefonda bu deger 0. */
    var bar = window.innerWidth - document.documentElement.clientWidth;
    if (bar <= 0) bar = barCache;
    body.style.position = 'fixed';
    body.style.top = -scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    if (bar > 0) body.style.paddingRight = bar + 'px';
  }

  function unlock() {
    if (!locked) return;
    locked = false;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.paddingRight = '';
    window.scrollTo(0, scrollY);
  }

  var observer = new MutationObserver(function () {
    if (body.classList.contains('menu-open')) {
      lock();
    } else {
      unlock();
      closeAll(null);
    }
  });
  observer.observe(body, { attributes: true, attributeFilter: ['class'] });

  /* --------------------------------------------------------- yeniden boyutlama */

  var wasDesktop = isDesktop();
  window.addEventListener(
    'resize',
    function () {
      measureBar();
      var now = isDesktop();
      if (now !== wasDesktop) {
        wasDesktop = now;
        closeAll(null);
        if (now) unlock();
      }
    },
    { passive: true }
  );

  /* ------------------------------------------------------------------- kurulum */

  function init() {
    bindDesktop();
    measureBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
